import { AccountReportDecryptionChartEntity } from '../entities/';
import { authResource } from './Auth';
export const AccountReportDecryptionChartResource = authResource({
    path: '/accounts/:accountId/reports/decryptions/chart/:chartId?',
    searchParams: {},
    schema: AccountReportDecryptionChartEntity
});
